<template>
</template>

<script>
export default {
  name: 'dummy',
  components: {},
  props: {
    filters: Array,
    filter: Object
  },
  data() {
    return {};
  },
  mounted() {
  },
  computed: {},
  emits: [],
  watch: {},
  methods: {},
}
</script>
